import {
  Tabs, Typography
} from 'antd';
import React from 'react';
import HeaderWrapper from '../../../components/headerWrapper';
import PageWrapper from '../../../components/pageWrapper';
import CostConfigView from './costConfigView/CostConfigView';
import OutlierView from './outlierView/OutlierView';


const { Title } = Typography;

const ConfigViewContainer = () => {
  const { TabPane } = Tabs;

  return (
    <PageWrapper>
      <HeaderWrapper>
        <Title level={3} style={{ color: 'var(--neutral--100)' }}>Configuration Settings</Title>
      </HeaderWrapper>
      <Tabs defaultActiveKey="1">
        <TabPane tab="Cost configuration" key="1">
          <CostConfigView />
        </TabPane>
        <TabPane tab="Outlier configuration" key="2">
          <OutlierView />
        </TabPane>
      </Tabs>
    </PageWrapper>
  );
};

export default ConfigViewContainer;
